import React from 'react';
import { ExternalIcon } from "../icons/ExternalIcon";
export var initialContextValue = {
    viewMoreIcon: React.createElement(ExternalIcon, null),
    viewMoreText: 'View More...'
};
export var DashboardPlateContext = React.createContext(initialContextValue);
//# sourceMappingURL=context.js.map